module.exports = __webpack_public_path__ + "img/cshy.25ea48e9.jpg";